(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-character"] && !Shopify.designMode) return;
  try {
    
(() => {
  const script = document.currentScript;
  const root =
    script &&
    (script.previousElementSibling?.closest?.('[data-section-id]') ||
     script.parentElement?.querySelector?.(':scope > [data-section-id]'));
  if (!root) return;

  const img = root.querySelector('img.sticker-bob');
  if (img && !img.getAttribute('alt')) img.setAttribute('aria-hidden', 'true');

  const path = root.querySelector('.sticker-path');
  if (!path) return;

  path.addEventListener('mouseenter', () => path.style.animationPlayState = 'paused');
  path.addEventListener('mouseleave', () => path.style.animationPlayState = 'running');

  let timer = null;
  const bubble = root.querySelector('.speech-bubble');
  if (bubble) {
    const pop = () => {
      path.classList.add('is-bubbling');
      clearTimeout(timer);
      timer = setTimeout(() => path.classList.remove('is-bubbling'), 2000);
    };
    path.addEventListener('touchstart', pop, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
